export default __webpack_public_path__ + "static/media/download.8d070317.svg";